


























import { computed, defineComponent, ref } from "@vue/composition-api";
import { MetadataField } from "@scrile/api-provider/dist/api/FileProvider";
import { getMediaDuration } from "@scrile/tools/dist/lib/TimeHelpers";
import { pauseGlobalPlayer } from "@/components/GlobalAudioPlayer/helpers";

const ONE_MILLISECOND = 1000;

export default defineComponent({
  name: "AudioPlayerController",
  props: {
    src: { type: String, required: true },
    audioPlayerClasses: { type: [String, Array] },
    metadata: { type: Object as () => Record<MetadataField | string, string> },
  },
  setup(props) {
    const audioPlayerRef = ref<HTMLAudioElement>();
    const isPlay = ref(false);
    const countedDuration = ref(0);
    const currentTime = ref(0);

    const duration = computed(() => {
      if (props.metadata?.duration) {
        return Number(props.metadata.duration);
      } else return countedDuration.value;
    });
    const remainingTime = computed(() => Math.floor(duration.value - currentTime.value));
    const formattedRemainingTime = computed(() => {
      return getMediaDuration(remainingTime.value || duration.value);
    });
    const percentageRemainingTime = computed(() => {
      return duration.value > 0 ? ((currentTime.value / duration.value) * 100).toFixed(2) : 0;
    });
    const isAudioPlaying = computed(() => (remainingTime.value !== 0 ? isPlay.value : false));
    const isPlayerReady = computed(() => audioPlayerRef.value && duration.value !== 0);

    const setTime = (milliseconds: number): void => {
      if (!audioPlayerRef.value) return;
      audioPlayerRef.value.currentTime = milliseconds / ONE_MILLISECOND;
    };

    const toggleAudio = (): void => {
      if (!isPlayerReady.value || !audioPlayerRef.value) return;
      if (isPlay.value) {
        audioPlayerRef.value.pause();
      } else {
        audioPlayerRef.value.play();
        pauseGlobalPlayer();
      }
    };
    const durationChangeHandler = () => {
      if (!audioPlayerRef.value) return;
      if (audioPlayerRef.value.duration === Infinity) {
        audioPlayerRef.value.addEventListener("timeupdate", () => setTime(0.001), { once: true });
        setTime(1e101);
        return;
      }
      countedDuration.value = Math.floor((audioPlayerRef.value?.duration ?? 0) * ONE_MILLISECOND);
    };
    const timeUpdateHandler = (): void => {
      currentTime.value = Math.floor((audioPlayerRef.value?.currentTime ?? 0) * ONE_MILLISECOND);
    };

    const onPlayPause = (status: boolean) => {
      isPlay.value = status;
      if (remainingTime.value === 0) {
        setTime(0);
      }
    };

    return {
      isPlay,
      duration,
      currentTime,
      isAudioPlaying,
      audioPlayerRef,
      formattedRemainingTime,
      percentageRemainingTime,
      setTime,
      toggleAudio,
      timeUpdateHandler,
      durationChangeHandler,
      onPlayPause,
    };
  },
});
